import MuiSelect from "@mui/material/Select";
import { styled } from "@mui/material/styles";

export const Select = styled(MuiSelect)(({ theme }) =>
    theme.unstable_sx({
        width: "100%",
        position: "relative",
        "&::before": {
            content: `""`,
            display: "block",
            height: 12,
            width: 16,
            position: "absolute",
            background: theme.palette.common.white,
            right: -1,
            top: -1,
            zIndex: 1,
        },
        border: `1px solid ${theme.palette.grey[400]}`,
        borderRadius: 2,
        "&.Mui-focused": {
            borderColor: theme.palette.grey[800],
        },
        "&.Mui-disabled": {
            borderColor: theme.palette.grey[400],
        },
        "&.Mui-disabled .MuiSelect-select": {
            color: theme.palette.grey[400],
        },
        "& fieldset.MuiOutlinedInput-notchedOutline": {
            border: 0,
        },
    }),
);
